$('aside ul li.menu-item-has-children').append(
  $(
    '<div class="menu-toggle"><i class="fa-sharp fa-solid fa-chevron-down"></i></div>'
  )
);

var menuRight = document.getElementById('ace-spmenu-s2'),
  showRightPush = document.getElementById('showRightPush'),
  menuClose = document.getElementById('menuClose'),
  body = document.body;

showRightPush.onclick = function () {
  var fixedHeader = document.querySelector('header');

  classie.toggle(this, 'active');
  classie.toggle(body, 'ace-spmenu-push-toleft');
  classie.toggle(menuRight, 'ace-spmenu-open');

  if (fixedHeader) {
    classie.toggle(fixedHeader, 'header-push-toleft');
  }
};

menuClose.onclick = function () {
  var fixedHeader = document.querySelector('header');

  classie.toggle(showRightPush, 'active');
  classie.toggle(body, 'ace-spmenu-push-toleft');
  classie.toggle(menuRight, 'ace-spmenu-open');

  if (fixedHeader) {
    classie.toggle(fixedHeader, 'header-push-toleft');
  }
};

document.addEventListener('click', function (e) {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;

  var fixedHeader = document.querySelector('header');

  classie.toggle(showRightPush, 'active');
  classie.toggle(body, 'ace-spmenu-push-toleft');
  classie.toggle(menuRight, 'ace-spmenu-open');

  if (fixedHeader) {
    classie.toggle(fixedHeader, 'header-push-toleft');
  }
});

$('aside .menu-toggle').on('click', function () {
  $(this).siblings('ul').slideToggle();
  $(this).toggleClass('fa-rotate-180');
});
